import { useEffect, useRef, useState } from 'react';
export const useResizeObserver = () => {
    const ref = useRef(null);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    useEffect(() => {
        const node = ref.current;
        let observer;
        try {
            observer = new ResizeObserver((entries) => {
                const lastEntry = entries.pop();
                if (lastEntry) {
                    const contentRect = Array.isArray(lastEntry.contentRect)
                        ? lastEntry.contentRect[0]
                        : lastEntry.contentRect;
                    setWidth(contentRect.width);
                    setHeight(contentRect.height);
                }
            });
            observer.observe(node);
        }
        catch (e) { }
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    });
    return {
        ref,
        width,
        height,
    };
};
//# sourceMappingURL=useResizeObserver.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
